import { render, staticRenderFns } from "./Checkout2.vue?vue&type=template&id=68a36307&scoped=true&"
import script from "./Checkout2.vue?vue&type=script&lang=js&"
export * from "./Checkout2.vue?vue&type=script&lang=js&"
import style0 from "./Checkout2.vue?vue&type=style&index=0&id=68a36307&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a36307",
  null
  
)

export default component.exports